import { PageShell } from './PageShell.js';
import type { WashedLocale } from '@washed/i18n';
import styles from './PageShell.module.css';

interface PageProps {
  locale: WashedLocale;
  onLocaleChange: (locale: WashedLocale) => void;
}

const COPY: Record<
  WashedLocale,
  {
    eyebrow: string;
    title: string;
    intro: string;
    emailLabel: string;
    waitlistLabel: string;
    waitlistText: string;
    locationLabel: string;
    location: string;
  }
> = {
  fr: {
    eyebrow: 'Washed · Contact',
    title: 'Nous contacter',
    intro: 'Une question, une demande presse, ou envie de rejoindre l’aventure ? Écrivez-nous.',
    emailLabel: 'Email',
    waitlistLabel: 'Liste d’attente',
    waitlistText: 'Rejoindre la liste d’attente',
    locationLabel: 'Où',
    location: 'Lomé, Togo',
  },
  en: {
    eyebrow: 'Washed · Contact',
    title: 'Contact us',
    intro: 'A question, a press request, or want to join the journey? Get in touch.',
    emailLabel: 'Email',
    waitlistLabel: 'Waitlist',
    waitlistText: 'Join the waitlist',
    locationLabel: 'Where',
    location: 'Lomé, Togo',
  },
};

export function ContactPage({ locale, onLocaleChange }: PageProps) {
  const c = COPY[locale];
  return (
    <PageShell
      locale={locale}
      onLocaleChange={onLocaleChange}
      eyebrow={c.eyebrow}
      title={c.title}
      intro={c.intro}
      cta={false}
    >
      <div className={styles.contactGrid}>
        <div className={styles.contactCard}>
          <p className={styles.contactLabel}>{c.emailLabel}</p>
          <p>
            <a href="mailto:contact@washedafrica.com">contact@washedafrica.com</a>
          </p>
        </div>
        <div className={styles.contactCard}>
          <p className={styles.contactLabel}>{c.waitlistLabel}</p>
          <p>
            <a href="/#rejoindre">{c.waitlistText}</a>
          </p>
        </div>
        <div className={styles.contactCard}>
          <p className={styles.contactLabel}>{c.locationLabel}</p>
          <p>{c.location}</p>
        </div>
      </div>
    </PageShell>
  );
}
